<template>
  <div class="nav-bar">
    <div class="read-only">
      <div>
        <b-button v-if="this.user && this.user.Permissions.editarpap.allowed" id='btLock' class="lockgroup" size="sm"
          @click="changeEditMode()">
          <b-icon v-if="!this.lock" class="lockIcon" icon="lock" aria-hidden="true" font-scale="1"></b-icon>
          <b-icon v-else icon="unlock" class="lockIcon" aria-hidden="true" font-scale="1"></b-icon>
        </b-button>
      </div>
      <div v-if="this.lock">
        <b-icon class="actionSimulation-navbar tools-nodes" :title="$t('papNavbarToolsIcon')" @click="openToolsNode"
          icon="tools"></b-icon>
      </div>
    </div>

    <div v-if="type == 'PAP' && scenarioOutdated" class="scenario-outdated-warning" title="Este cenário não é compatível com o cenário padrão">
      Este cenário não é compatível com o cenário padrão
    </div>
    <div v-if="type == 'PAP'" class="scenarioInfo" :title="scenarioName">{{ $t('papNavbarScenery') }} {{ scenarioName }}
    </div>
    <div v-if="type == 'PAP' && scenarioName">
      <i
        class="fa fa-folder-open save-scenario"
        title="Gestão de cenários"
        @click="openScenarioManagerFromPAP"
      ></i>
    </div>

    <div v-if="scenarioPeriod != 'null' && type == 'PCP'" class="referenceInfo" :title="scenarioPeriod">
      {{ $t('papNavbarReference') }} {{ scenarioPeriod }}</div>
    <div v-if="type == 'PCP'" class="ref-select referenceInfoYear">
      <p class="mr-2 yearText noselect">Ano Base</p>
      <b-form-select v-model="yearSelected" class="select-view noselect">
        <template #first>
          <b-form-select-option :value="null">Selecione o ano</b-form-select-option>
        </template>
        <b-form-select-option v-for="year in plansWithBaseYearsAndRevision" :key="year.id" :value="year.baseYear">{{
          year.baseYear
        }}</b-form-select-option>
      </b-form-select>
      <p class="mr-2 ml-2 yearText noselect">Revisão</p>
      <b-form-select v-model="revisionSelected" class="select-view noselect mr-2">
        <template #first>
          <b-form-select-option :value="null">Selecione a revisão</b-form-select-option>
        </template>
        <b-form-select-option v-for="revision in revisions" :key="revision.id" :value="revision">{{
          revision.description
        }}</b-form-select-option>
      </b-form-select>
    </div>
    <div>
      <b-icon @click="() => changeArea('PAP')" class="actionSimulation-navbar back-pap" :title="$t('papHover')"
        icon="house-door-fill"></b-icon>
    </div>
    <div>
      <img @click="() => changeArea('Balanço Hídrico')" id="hidrico" class="noselect" src="@/assets/hidrico.png"
        :title="$t('hydricBalance')" alt="Balanço hídrico" />
    </div>
    <div>
      <img @click="() => changeArea('Ocupações')" id="ocupacao" class="noselect" src="@/assets/ocupacao.png"
        :title="$t('occupations')" alt="Ocupações" />
    </div>
    <div>
      <img id="" class="noselect" src="@/assets/regressar.png" :title="$t('return')" alt="Retornar" @click="backFlow" />
    </div>
    <div>
      <b-icon @click="play" class="actionSimulation-navbar play-simulation" :title="$t('executeSimulationButtom')"
        icon="play-fill"></b-icon>
    </div>
    <div>
      <img @click="goalSeek" id="atingirmeta" class="noselect" src="@/assets/atingirmeta.png"
        :title="$t('achieveGoals')" alt="Atingir Metas" />
    </div>
    <div>
      <img @click="sensitivityAnalysis" id="analisesensibilidade" class="noselect"
        src="@/assets/analisesensibilidade.png" :title="$t('sensitivityAnalysis')" alt="Análise de Sensibilidade" />
    </div>
    <div v-if="type == 'PAP' && user && user.Permissions && user.Permissions.rtoconfigurar && user.Permissions.rtoconfigurar.allowed">
      <img
        id="rtoconfig"
        class="noselect rto-config-btn"
        src="@/assets/configuracao.svg"
        title="Configurações RTO"
        alt="Configurações RTO"
        @click="$emit('openRtoDrawer')"
      />
    </div>
    <div v-if="type == 'PAP' && user && user.Permissions && user.Permissions.rtoconfigurar && user.Permissions.rtoconfigurar.allowed">
      <b-icon
        icon="play-fill"
        class="actionSimulation-navbar rto-execute-btn"
        title="Assistente de Otimização"
        @click="$emit('openRtoAssistente')"
      />
    </div>
    <div v-if="type == 'PAP' && user && user.Permissions && user.Permissions.rtoconfigurar && user.Permissions.rtoconfigurar.allowed">
      <b-icon
        :icon="rtoActive ? 'toggle-on' : 'toggle-off'"
        class="actionSimulation-navbar rto-toggle-btn"
        :class="{ 'rto-toggle-btn--active': rtoActive }"
        :title="rtoActive ? 'RTO ativo neste cenário — clique para desativar' : 'Ativar RTO neste cenário'"
        @click="toggleRtoActive"
      />
    </div>

    <div class="ref-select">
      <p class="mr-2 noselect">{{ $t('visualization') }}</p>
      <b-form-select v-model="attrSelected" class="select-view noselect">
        <template #first>
          <b-form-select-option :value="null">{{ $t('pattern') }}</b-form-select-option>
        </template>
        <b-form-select-option value="W">{{ $t('massFlow') }}</b-form-select-option>
        <b-form-select-option value="WVol">{{ $t('volumetricFlow') }}</b-form-select-option>
        <b-form-select-option value="P">{{ $t('pressure') }}</b-form-select-option>
        <b-form-select-option value="T">{{ $t('temperature') }}</b-form-select-option>
        <b-form-select-option value="POL">{{ $t('pol') }}</b-form-select-option>
        <b-form-select-option value="ART">{{ $t('art') }}</b-form-select-option>
        <b-form-select-option value="AR">{{ $t('ar') }}</b-form-select-option>
        <b-form-select-option value="brix">{{ $t('brix') }}</b-form-select-option>
        <b-form-select-option value="pureza">{{ $t('purity') }}</b-form-select-option>
        <b-form-select-option value="pot">{{ $t('potency') }}</b-form-select-option>
      </b-form-select>
    </div>

    <FormOperation :dialogVisibleShow="showDialogReadOnly">
    </FormOperation>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onEventBuss, urlMainAPI, defaultSuccess, showError } from '../../global';
import { rtoErrorMessage } from './rtoErrors';
import FormOperation from "../flowchart/dialogForm/FormOperation"
import axios from "axios";

export default {
  name: "PapNavBar",
  computed: mapState(["user", "updateModeEditor", "scenarioName", "scenarioOutdated", "rtoActive"]),

  props: [
    "editorMode",
    "scenarioPeriod",
    "yearPeriod",
    "revisionPeriod",
    "type",
    "updateInfoPCP"
  ],

  components: {
    FormOperation,
  },

  data() {
    return {
      lock: this.editorMode,
      ref: "Padrão",
      attrSelected: null,
      clicked: 0,
      showDialogReadOnly: false,
      referenceMonth: null,
      yearSelected: null,
      revisionSelected: null,
      plansWithBaseYearsAndRevision: null,
      revisions: []
    }
  },
  watch: {
    attrSelected(value) {
      this.$emit("attrSelected", value)
    },
    yearSelected(value) {
      this.revisions = this.plansWithBaseYearsAndRevision.find(p => p.baseYear == value).revisions
      this.revisionSelected = null
    },
    revisionSelected(value) {
      if (value) {
        this.$emit("yearPeriod", this.yearSelected)
        this.$emit("revisionPeriod", value)
      }
    },
    async updateInfoPCP(value) {
      if (value != null) {
        let oldValue = this.yearSelected;
        await this.loadBaseYears()
        this.revisions = this.plansWithBaseYearsAndRevision.find(p => p.baseYear == oldValue).revisions
        this.yearSelected = oldValue;
        this.revisionSelected = this.revisions.find(b => b.id == value.planId)
      }
    }
  },

  methods: {
    changeEditMode() {
      this.lock = !this.lock
      this.$emit("editorMode", this.lock);
    },

    backFlow() {
      this.clicked++;
      this.$emit("returnClicked", this.clicked);
    },

    play() {
      this.clicked++;
      this.attrSelected = null;
      this.$emit("executeSimulation", this.clicked);
    },

    goalSeek() {
      this.clicked++
      this.$emit("openGoalSeek", this.clicked);
    },

    sensitivityAnalysis() {
      this.clicked++
      this.$emit("openSensitivityAnalysis", this.clicked);
    },

    changeArea(value) {
      this.clicked++
      this.$emit("flowChartTo", {
        area: value,
        clicked: this.clicked
      });
    },

    openToolsNode() {
      this.showDialogReadOnly++
    },

    openScenarioManagerFromPAP() {
      this.$store.commit('setScenarioManagerAutoSelect', true);
      this.$bvModal.show('modalScenarioManager');
    },

    async toggleRtoActive() {
      const next = !this.rtoActive;
      // CA-01.1: ao ATIVAR, propaga atributos casados do XML PADRAO PAP
      // para o XML PADRAO RTO antes de ligar o monitoramento. Espelha o
      // espírito do DDS-RTO-2026-001 v7.0 ("modelo único compartilhado").
      if (next) {
        const synced = await this.syncPapToRtoBeforeActivate();
        if (!synced) return; // erro fatal — não ativa
      }
      // EStatusOtimizador do RTO: 1 = Ativo, 2 = Inativo. Controla o
      // monitoramento constante de gatilhos (kill switch global).
      const statusOtimizador = next ? 1 : 2;
      try {
        // skipGlobalErrorHandler: o interceptor mostraria o dump tecnico do .NET
        // ("...maquina de destino as recusou..."). Nos catch abaixo usamos
        // rtoErrorMessage que substitui por mensagem clara em casos de RTO offline.
        await axios.put(`${urlMainAPI}/configurator/rto/configuracao/status?statusOtimizador=${statusOtimizador}`, null, { skipGlobalErrorHandler: true });
        this.$store.commit('setRtoActive', next);
      } catch (err) {
        console.error('Falha ao alternar o monitoramento do RTO:', err);
        showError(rtoErrorMessage(err, 'Falha ao alternar o monitoramento do RTO.'));
        // Sem comunicação com o RTO, o monitoramento NÃO está ativo — independente do estado
        // anterior. Forçar inativo evita a inconsistência de mostrar "RTO ATIVO" com o serviço
        // fora do ar. Quando o RTO voltar, o usuário pode reativar manualmente.
        this.$store.commit('setRtoActive', false);
      }
    },

    async syncPapToRtoBeforeActivate() {
      // CA-01.1 é "best effort": se algum pré-requisito do sync faltar, avisa mas
      // não bloqueia a ativação do kill switch (statusOtimizador=1). O RTO continua
      // funcionando mesmo sem cenário PADRAO RTO — só não há XML pra propagar.
      try {
        const treeRes = await axios.get(`${urlMainAPI}/getscenariotree`);
        const flat = [];
        this.flattenScenarioTree(treeRes.data, flat);

        const isPadrao = (s) => !s.isFolder && (s.name || '').toUpperCase() === 'PADRAO';
        const padraoPap = flat.find(s => isPadrao(s) && (s.scenarioType ?? 'PGDI') === 'PGDI');
        const padraoRto = flat.find(s => isPadrao(s) && s.scenarioType === 'RTO');

        if (!padraoPap && !padraoRto) {
          defaultSuccess('RTO ativado. Sem cenários PADRAO PAP/RTO cadastrados — sincronização XML pulada.');
          return true;
        }
        if (!padraoPap) {
          defaultSuccess('RTO ativado. Cenário PADRAO PAP não encontrado — sincronização XML pulada. Crie o PADRAO PGDI para habilitar.');
          return true;
        }
        if (!padraoRto) {
          defaultSuccess('RTO ativado. Cenário PADRAO RTO não encontrado — sincronização XML pulada. Importe um XML RTO no Gerenciador de Cenários para habilitar.');
          return true;
        }

        const [papRes, rtoRes] = await Promise.all([
          axios.get(`${urlMainAPI}/getscenario/${padraoPap.id}`),
          axios.get(`${urlMainAPI}/getscenario/${padraoRto.id}`),
        ]);
        const xmlPap = this.extractScenarioXml(papRes.data);
        const xmlRto = this.extractScenarioXml(rtoRes.data);

        if (!xmlPap || !xmlRto) {
          defaultSuccess('RTO ativado. Não foi possível carregar os XMLs PADRAO — sincronização XML pulada.');
          return true;
        }

        const { xmlMerged, semCorrespondencia } = this.mergeXmlPapIntoRto(xmlPap, xmlRto);

        try {
          await axios.post(`${urlMainAPI}/savesimulationscenario`, {
            name: padraoRto.name,
            scenario: xmlMerged,
            scenarioResult: null,
            parentId: padraoRto.parentId,
            scenarioType: 'RTO',
          });
        } catch (e) {
          if (e?.response?.status === 403) {
            defaultSuccess('RTO ativado. Cenário PADRAO RTO está protegido (isLocked) — sincronização XML pulada. Peça ao admin Pentagro para liberar.');
            return true;
          }
          throw e;
        }

        if (semCorrespondencia.length > 0) {
          defaultSuccess(`RTO ativado e sincronizado com PADRAO PAP. ${semCorrespondencia.length} parâmetro(s) sem correspondente no RTO foram ignorados (mantidos como estavam).`);
        } else {
          defaultSuccess('RTO ativado e sincronizado com o cenário PADRAO PAP.');
        }
        return true;
      } catch (e) {
        console.error('Erro ao sincronizar PAP→RTO antes de ativar:', e);
        // Erro inesperado: ainda ativa o RTO (kill switch é independente do sync),
        // mas avisa pra o usuário poder investigar.
        showError(rtoErrorMessage(e, 'Falha ao sincronizar PAP→RTO. RTO será ativado mesmo assim — verifique o console.'));
        return true;
      }
    },

    flattenScenarioTree(nodes, acc) {
      if (!Array.isArray(nodes)) return;
      for (const n of nodes) {
        acc.push(n);
        if (Array.isArray(n.children) && n.children.length > 0) {
          this.flattenScenarioTree(n.children, acc);
        }
      }
    },

    extractScenarioXml(data) {
      if (!data) return null;
      if (typeof data === 'string') {
        try { return JSON.parse(data)?.scenario ?? null; } catch { return null; }
      }
      return data.scenario ?? null;
    },

    mergeXmlPapIntoRto(xmlPap, xmlRto) {
      const parser = new DOMParser();
      const docPap = parser.parseFromString(xmlPap, 'application/xml');
      const docRto = parser.parseFromString(xmlRto, 'application/xml');

      if (docPap.querySelector('parsererror') || docRto.querySelector('parsererror')) {
        throw new Error('XML inválido (parser error).');
      }

      // Indexa elementos do RTO por tag+name para casamento O(1)
      const rtoIndex = new Map();
      const rtoElements = docRto.querySelectorAll('[name]');
      rtoElements.forEach(el => {
        rtoIndex.set(`${el.tagName}|${el.getAttribute('name')}`, el);
      });

      const semCorrespondencia = [];

      // Para cada elemento com [name] no PAP, propaga atributos para o RTO.
      // CA-01.3: se não há mapeamento, registra mas não falha — mantém o RTO como estava.
      const papElements = docPap.querySelectorAll('[name]');
      papElements.forEach(elPap => {
        const tag = elPap.tagName;
        const name = elPap.getAttribute('name');
        if (!name) return;

        const elRto = rtoIndex.get(`${tag}|${name}`);
        if (!elRto) {
          semCorrespondencia.push(`${tag}[${name}]`);
          return;
        }

        // Copia atributos do PAP que TAMBÉM existem no RTO. Preserva atributos
        // exclusivos do RTO (não sobrescreve com inexistentes), preserva 'name'.
        Array.from(elPap.attributes).forEach(attr => {
          if (attr.name === 'name') return;
          if (elRto.hasAttribute(attr.name)) {
            // vmC está em porcentagem no PAP; o RTO espera fração — divide por 100.
            const value = attr.name === 'vmC' ? this.scalePercentToFraction(attr.value) : attr.value;
            elRto.setAttribute(attr.name, value);
          }
        });
      });

      const xmlMerged = new XMLSerializer().serializeToString(docRto);
      return { xmlMerged, semCorrespondencia };
    },

    scalePercentToFraction(raw) {
      if (raw === null || raw === undefined || raw === '') return raw;
      const num = parseFloat(String(raw).replace(',', '.'));
      if (!Number.isFinite(num)) return raw;
      const usedComma = String(raw).includes(',');
      const out = (num / 100).toString();
      return usedComma ? out.replace('.', ',') : out;
    },

    async loadBaseYears() {
      const url = `${urlMainAPI}/getproductionplanswithrevisionsbyyear`;
      await axios
        .get(url)
        .then((res) => {
          this.plansWithBaseYearsAndRevision = res.data;
        })
        .catch((err) => {
          console.warn("Erro ao carregar anos base:", err.message);
        });
    },

    mounted() {
      onEventBuss("OpentToolsNode", this.openToolsNode)
    },

    destroyed() {
      this.lock = false;
    },
  },

  async created() {
    if (this.type === 'PCP') {
      await this.loadBaseYears();
    }
  }
}
</script>

<style>
.nav-bar>div>svg.play-simulation {
  margin-left: 4px;
  font-size: 36px;
  cursor: pointer;
  color: #ff5f00;
}

.nav-bar>div>svg.save-scenario,
.nav-bar>div>i.save-scenario {
  margin-left: 4px;
  font-size: 22px;
  cursor: pointer;
  color: #ff5f00;
  vertical-align: middle;
}

.nav-bar>div>i.save-scenario:active {
  color: #ff5f0050;
  transition-duration: 50ms;
}

.nav-bar>div>div>svg.tools-nodes,
.nav-bar>div>svg.back-pap {
  margin-left: 4px;
  cursor: pointer;
  color: #ff5f00;
  font-size: 24px;
}

.nav-bar>div>div>svg.tools-nodes {
  font-size: 19px;
  position: absolute;
  top: 5px;
}

.nav-bar>div>div>svg.tools-nodes:hover,
.nav-bar>div>svg.back-pap:hover,
.nav-bar>div>svg.play-simulation:hover {
  transition-duration: 500ms;
}

.nav-bar>div>div>svg.tools-nodes:active,
.nav-bar>div>svg.back-pap:active,
.nav-bar>div>svg.play-simulation:active {
  color: #ff5f0050;
  transition-duration: 50ms;
}
</style>

<style scoped>
.nav-bar {
  margin: 8px;
  display: flex;
  align-items: center;
  justify-content: right;
  position: relative;
  top: -2px;
  left: -10px;
  width: 100%;
  height: 30px;
}

.nav-bar>div:first-child {
  width: 100%;
  justify-content: flex-start;
}

.nav-bar>div:last-child {
  display: flex;
  justify-items: center;
  align-items: center;
  min-width: 224px;
}

.nav-bar>div {
  padding-left: 10px;
}

.nav-bar>div>img {
  width: 23px;
  height: 23px;
  cursor: pointer;
}

.scenarioInfo {
  width: 250px;
  min-width: 250px;
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis !important;
  font-size: 0.85rem;
  text-align: end;
}

.scenario-outdated-warning {
  white-space: nowrap;
  font-size: 0.8rem;
  color: #842029;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 2px 8px;
}

.referenceInfo {
  width: 330px;
  margin-top: 2px;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
  font-size: 0.85rem;
  text-align: center;
  color: #ff5f00;
}

.referenceInfoYear {
  font-size: 0.85rem;
  color: #ff5f00;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  text-align: center;
}

#analisesensibilidade {
  width: 30px;
  height: 32px;
}

#rtoconfig {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: -5px;
}

.rto-config-btn {
  cursor: pointer;
}

.rto-config-btn:hover {
  opacity: 0.75;
  transition-duration: 300ms;
}

.rto-execute-btn {
  margin-left: 4px;
  font-size: 36px;
  cursor: pointer;
  color: #00a39f;
}

.rto-execute-btn:hover {
  opacity: 0.75;
  transition-duration: 300ms;
}

.rto-execute-btn:active {
  color: #00a39f50;
  transition-duration: 50ms;
}

.rto-toggle-btn {
  font-size: 24px;
  cursor: pointer;
  color: #9ca3af;
}

.rto-toggle-btn--active {
  color: #16a34a;
}

.rto-toggle-btn:hover {
  opacity: 0.75;
  transition-duration: 300ms;
}

.rto-toggle-btn:active {
  opacity: 0.4;
  transition-duration: 50ms;
}

#eficiencia {
  width: 37px;
  height: 23px;
}

#hidrico {
  width: 27px;
  height: 25px;
}

#ocupacao {
  width: 27px;
  height: 30px;
}

.nav-bar>div>img:active {
  opacity: 0.5;
}

.nav-bar>div>p {
  margin: 0;
}

.yearText {
  margin: 0;
  margin-top: 2px !important;
}

#tools-nodes,
.lockgroup,
.lockIcon {
  color: #ff5f00 !important;
  font-size: 14px;
  background-color: #0000;
  border: none;
  outline: none;
}

#tools-nodes {
  font-size: 21px;
}

#tools-nodes:hover {
  transition-duration: 500ms;
}

#tools-nodes:active {
  color: #ff5f0050;
  transition-duration: 50ms;
}

.lockgroup:focus {
  box-shadow: none;
}

.lockgroup:active {
  color: #000;
  background-color: #0000;
}

.lockIcon {
  color: red;
}

.select-view {
  min-width: 100px;
}

.read-only {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.ref-select {
  display: flex;
  align-items: center;
}

/* Neutraliza o gap de baseline dos ícones inline (svg/img) da navbar para que todos
   centralizem naturalmente na linha — alinhando com o texto "Visualização" + select.
   Mesmo padrão já usado em .save-scenario. */
.nav-bar>div>svg,
.nav-bar>div>img {
  vertical-align: middle;
}

.ref-select>p,
.ref-select select {
  margin: 0;
  font-size: 0.85rem;
}

.ref-select select {
  height: 23px;
  padding: 1px 5px;
  min-width: 138px;
}

@media only screen and (max-width: 817px) {
  .scenarioInfo {
    display: none !important;
  }
}

@media only screen and (max-width: 605px) {
  div.ref-select {
    display: none !important;
  }
}

@media only screen and (max-width: 321px) {

  #atingirmeta,
  #analisesensibilidade,
  #eficiencia,
  #hidrico,
  #ocupacao,
  div.ref-select {
    display: none !important;
  }

  .nav-bar>div:first-child {
    width: calc(100% - 70px);
  }
}
</style>
